module.exports = __webpack_public_path__ + "media/country_flags/ch-693031df.png";